import { render } from "./WizardBackButton.vue?vue&type=template&id=42c8be4b&scoped=true"
import script from "./WizardBackButton.vue?vue&type=script&lang=ts"
export * from "./WizardBackButton.vue?vue&type=script&lang=ts"

import "./WizardBackButton.vue?vue&type=style&index=0&id=42c8be4b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-42c8be4b"

export default script